import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const links = Array.from(this.element.querySelectorAll("a")).filter(link => {
      return link.parentElement?.classList.contains('page_link') || link.querySelector('.page_link');
    });

    links.forEach(link => {
      const url = link.href || link.querySelector("a")?.href;
      if (!url) return;

      fetch(`/note/meta_tags?url=${encodeURIComponent(url)}`)
        .then(response => response.json())
        .then(({ title, image }) => {
          const hasImage = !!image;

          const container = document.createElement("a");
          container.href = url;
          container.target = "_blank";
          container.classList.add("rich-link");

          container.innerHTML = `
            <div class="rich-link__image">
              ${hasImage ? `<img src="${image}" alt="">` : ""}
            </div>
            <div class="rich-link__content">
              <p class="rich-link__title">${title}</p>
            </div>
          `;

          link.replaceWith(container);
        })
        .catch(error => {
          console.error("OGP fetch failed:", error);
        });
    });
  }
}
